import styled from '@emotion/styled'
import type { NextPage } from 'next'
import router from 'next/router'
import { useState, VFC } from 'react'

import Button from '~/components/global/CButton'
import { SkyOnlyLayout } from '~/components/layout/SkyOnly'

const spWidth = 599
const pcWidth = 1023

const Shindan = styled.div`
    padding: 0 12%;
    padding-top: 32vh;
    @media (max-width: ${spWidth}px) {
        padding: 0 6%;
        padding-top: 26vh;
    }
    @media (orientation: landscape) and (max-width: ${pcWidth}px) {
        padding: 0 124px;
        padding-top: 2vh;
    }
`

const ShindanArea = styled.div`
    background: url(/images/character/kishidan.png) no-repeat bottom,
        linear-gradient(180deg, rgba(3, 110, 183, 0.4) 60.38%, rgba(255, 255, 255, 0.4) 100%);
    background-size: contain;
    box-shadow: 0px 0px 100px rgba(255, 255, 255, 0.25);
    display: flex;
    position: relative;
    flex-direction: column;
    margin: auto;
    width: 100%;
    max-width: 900px;
    height: 400px;
    padding: 40px 12px;
    z-index: 100;
    @media (max-width: ${spWidth}px) {
        padding: 24px 12px;
    }
    @media (orientation: landscape) and (max-width: ${pcWidth}px) {
        padding: 18px 12px;
    }
`

const ShindanForm = styled.div`
    margin: auto;
    margin-top: 40px;
    display: flex;
    z-index: 50;
`
export type ShindanPageViewProps = {
    handlerChange: (e: React.ChangeEvent<HTMLInputElement>) => void
    onClickShindan: () => void
    isShowError: boolean
}

export const ShindanPageView: VFC<ShindanPageViewProps> = ({ handlerChange, onClickShindan, isShowError }) => {
    return (
        <SkyOnlyLayout>
            <Shindan>
                <ShindanArea>
                    {isShowError && (
                        <p className="flex justify-center mb-4 text-red-600 font-bold w-full md:text-xl text-sm">
                            一文字以上入力して下さい
                        </p>
                    )}
                    <div className="flex flex-col m-auto z-50">
                        <p className="text-c-secondary font-RocknRoll md:text-5xl text-2xl text-center">獣の騎士団メーカー</p>
                        <div className="flex flex-col justify-center text-center text-[#ffffff] font-RocknRoll md:mt-12 mt-8 md:text-xl text-base">
                            <p>あなたは何の騎士？</p>
                            <p>名前を入力して今すぐ診断！</p>
                        </div>
                        <ShindanForm>
                            <input
                                className="border-4 rounded-md px-4 h-16 md:w-[368px] w-[280px] border-c-primary text-c-primary bg-white md:text-lg text-base"
                                placeholder="診断したい名前を入力！"
                                type="text"
                                name="name"
                                onChange={(e) => handlerChange(e)}
                            />
                        </ShindanForm>
                        <div className="md:mt-4 mt-2 m-auto z-50">
                            <Button label="診断する" onClick={() => onClickShindan()} />
                        </div>
                    </div>
                    <div className="absolute md:w-[189px] md:h-[620px] md:-left-24 md:-top-12 -bottom-8 -left-8">
                        <img
                            src="/images/character/samidare-pc.png"
                            alt="朝日奈さみだれ"
                            srcSet="/images/character/samidare.png 900w"
                        />
                    </div>
                    <div className="absolute md:w-[207px] md:h-[620px] md:-right-20 md:-top-12 -bottom-8 -right-7">
                        <img src="/images/character/amamiya-pc.png" alt="雨宮夕日" srcSet="/images/character/amamiya.png 900w" />
                    </div>
                </ShindanArea>
            </Shindan>
        </SkyOnlyLayout>
    )
}

export const ShindanPage: NextPage = () => {
    const [input, setInputVal] = useState('')
    const [isShowError, setErrorState] = useState(false)

    const handlerChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputVal(e.target.value)
    }

    const onClickShindan = async () => {
        if (input == '') setErrorState(true)
        else {
            await router.push({
                pathname: 'shindan/result',
                query: {
                    input,
                },
            })
        }
    }

    return <ShindanPageView handlerChange={handlerChange} onClickShindan={onClickShindan} isShowError={isShowError} />
}

export default ShindanPage
